import React from "react";
import { useAuth, useCurrentTalentProfile } from "../../hooks";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import CustomTab from "../common/CustomTab";
import TalentProfile from "./TalentProfile";
import TalentPost from "./TalentPost";
import Reviews from "./Reviews";
import Queries from "./Queries";
import { useGetATalent } from "../../services/api/talent.api";

const tabs = [
  { label: "General", value: "general" },
  { label: "Posts", value: "posts" },
  { label: "Reviews", value: "reviews" },
  { label: "Queries", value: "queries" },
];

export const ProfileManagement: React.FC = () => {
  const { userInfo } = useAuth();
  const { currentProfile } = useCurrentTalentProfile();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "general";

  const handleTabChange = (newValue:
    
string) => {
    setSearchParams({ tab: newValue });
  };

  const { data: talent } = useGetATalent({
    key: ["talent", currentProfile?.id],
    params: {
      id: Number(currentProfile?.id),
    },
    options: {
      enabled: !!currentProfile?.id,
    },
  });

  if (!talent) {
    return <div>Loading...</div>;
  }
  console.log(talent?.data, "talents skills");
  const renderTabContent = () => {
    switch (currentTab) {
      case "general":
        return <TalentProfile userInfo={userInfo} talentInfo={talent?.data} />;

      case "posts":
        return <TalentPost />;
      case "reviews":
        return <Reviews />;
      case "queries":
        return <Queries />;
      default:
        return <TalentProfile userInfo={userInfo} talentInfo={talent?.data} />;
    }
  };

  return (
    <>
      <Box sx={{ py: { xs: 1, sm: 2 } }}>
        <CustomTab
          tabs={tabs}
          value={currentTab}
          onChange={(_, newValue) => handleTabChange(newValue.toString())}
        />
      </Box>
      {renderTabContent()}
    </>
  );
};
